module.exports = __webpack_public_path__ + "static/media/orpea-residences-reland.52515b3f.jpg";